import { isNativeApp } from '../utils/platform';

/** User override stored on device (Profile → API settings in native app). */
export const MOBILE_API_STORAGE_KEY = 'gadkot_mobile_api_base';

/** Default when app is installed on phone and no env is baked in at build time. */
export const NATIVE_DEFAULT_API_BASE = 'https://gadkot.com';

export function getStoredMobileApiBase() {
  try {
    const v = localStorage.getItem(MOBILE_API_STORAGE_KEY);
    return v && String(v).trim() ? String(v).trim().replace(/\/$/, '') : '';
  } catch {
    return '';
  }
}

export function setStoredMobileApiBase(url) {
  try {
    const trimmed = String(url || '').trim().replace(/\/$/, '');
    if (!trimmed) localStorage.removeItem(MOBILE_API_STORAGE_KEY);
    else localStorage.setItem(MOBILE_API_STORAGE_KEY, trimmed);
  } catch {
    // ignore
  }
}

/**
 * Resolved API origin for all fetch calls.
 * Priority: localStorage override → REACT_APP_API_BASE_URL → native default → dev localhost.
 */
export function resolveApiBaseUrl() {
  const stored = getStoredMobileApiBase();
  if (stored) return stored;

  const fromEnv = process.env.REACT_APP_API_BASE_URL;
  if (fromEnv != null && String(fromEnv).trim() !== '') {
    return String(fromEnv).trim().replace(/\/$/, '');
  }

  if (isNativeApp()) {
    return NATIVE_DEFAULT_API_BASE;
  }

  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8080';
  }

  return '';
}
